import { TConfig, TDiscount } from '@@/auto/interfaces';

export const possiblePartnerDiscounts = {
  'Credit Karma': 'Credit Karma Member',
  Carvana: 'Carvana Customer Discount',
  Toyota: 'Toyotally Awesome Discount',
};

export const AUTO_DISCOUNTS: Record<string, TDiscount> = {
  accidentFree: {
    title: 'New Business Five Year Accident Free Discount',
    description:
      "You are eligible for this discount if, at the time of initial purchase, none of the insured drivers on the policy have had an accident, unverifiable driving record or foreign driver's license in the past 5 years.",
  },
  accidentPrevention: {
    title: 'Accident Prevention Course Discount',
    description:
      'A driver is eligible for this discount if they have completed an approved motor vehicle accident prevention course of at least four hours in duration using a nationally recognized driver training curriculum or a curriculum approved by a state or federal agency within the past 36 months. The discount is not applicable if the course was required because of a moving traffic violation but if applied, will be valid for a three-year period. Verification may be required.',
  },
  aeb: {
    title: 'Automatic Emergency Braking Discount',
    description:
      'You are eligible for this discount if your car is equipped with factory installed Automatic Emergency Braking (AEB), a vehicle safety system (more advanced than anti-lock brakes) that detects an impending forward crash and alerts the driver to avoid or mitigate the crash.',
  },
  caAffinity: {
    title: 'Affinity Discount',
    description:
      'You are eligible for this discount if you or your spouse is a member of certain affinity or occupation groups.',
  },
  affinity: {
    title: 'Partner Discount',
    description:
      'You are eligible for this discount if you purchased your Toggle policy through one of our affinity partners, including but not limited to automobile retailers and distributors, financial services institutions, and automobile original equipment manufacturers.',
  },
  airBag: {
    title: 'Air Bag Discount',
    description: `Your vehicle is eligible for this discount if it has one or more factory-installed air bag(s).`,
  },
  antiLockBrake: {
    title: 'Anti-Lock Brake Discount',
    description: `A vehicle is eligible for this discount if it is equipped with factory installed anti-lock brakes on all four wheels.`,
  },
  antiTheft: {
    title: 'Anti-Theft Discount',
    description:
      'A vehicle is eligible for this discount if it is equipped with anti-theft mechanisms. Anti-theft mechanism is any passive or active anti-theft system/anti-theft devices permanently installed, either as original equipment from the manufacturer or as after market equipment on the vehicle that is designed to inhibit the theft of the vehicle or its components.',
  },
  antiTheftFl: {
    title: 'Anti-Theft Discount',
    description: `A vehicle is eligible for this discount if it is equipped with a passive anti-theft device. A passive anti-theft device is defined as any item or system installed in an automobile which is activated automatically when the operator turns the ignition key to the off position and which is designed to prevent unauthorized use. The term does not include an ignition interlock provided as a standard anti-theft device by the original automobile manufacturer.`,
  },
  antiTheftPa: {
    title: 'Anti-Theft Discount',
    description: `A vehicle is eligible for this discount if it is equipped with a passive anti-theft device. A passive anti-theft device is defined as any item or system installed in an automobile which is activated automatically when the operator turns the ignition key to the off position and which is designed to prevent unauthorized use. The term does not include an ignition interlock provided as a standard anti-theft device by the original automobile manufacturer.`,
  },
  claimFree: {
    title: 'Five Year Claim Free Discount',
    description:
      "You are eligible for this discount if none of the insured drivers on the policy have had an unverifiable driving record, foreign driver's license, or auto insurance claim with Toggle for the past five years.",
  },
  continuousInsurance: {
    title: 'Continuous Insurance Discount',
    description:
      "You are eligible for this discount if you've been consistently insured with another insurance carrier prior to Toggle, with no gaps or lapses in coverage. The amount of the discount depends on the length of continuous insurance.",
  },
  defensiveDriver: {
    title: 'Defensive Driver Discount',
    description:
      'You are eligible for this discount if you have completed an approved driver training course within the last three years. The discount is not applicable if the course was required because of a driving offense or traffic violation but if applied, will be valid for a three-year period. Verification may be required.',
  },
  defensiveDriverAll: {
    title: 'Defensive Driver Discount',
    description:
      'You are eligible for this discount if all insured drivers have completed an approved driver training course within the last three years. The discount is not applicable if the course was required because of a driving offense or traffic violation but if applied, will be valid for a three-year period.',
  },
  distantStudent: {
    title: 'Distant Student Discount',
    description:
      'You are eligible for this discount if an insured driver on the policy, other than the primary named insured or spouse, is a student under the age of 23, who moves away to school more than 100 miles from your residence, and does not have regular access to the covered vehicles while away at school. Verification may be required.',
  },
  distantStudent25: {
    title: 'Distant Student Discount',
    description:
      'You are eligible for this discount if an insured driver on the policy, other than the primary named insured or spouse, is a student under the age of 25, who moves away to school more than 100 miles from your residence, and does not have regular access to the covered vehicles while away at school. Verification may be required.',
  },
  driverImprovementDiscount: {
    title: 'Driver Improvement Discount',
    description:
      'You are eligible for this discount if all insured drivers 55 or older have completed an approved driver improvement course within the last three years. The discount is not applicable if the course was required because of a driving offense or traffic violation but if applied, will be valid for a three-year period. Verification may be required.',
  },
  goodDriver: {
    title: 'Good Driver Discount',
    description:
      'You are eligible for this discount if you have been continuously licensed for the most recent three-year period; have incurred no more than one minor traffic conviction or one non-injury at-fault accident in the past three years; and have had no major violation in the past ten years.',
  },
  goodStudent: {
    title: 'Good Student Discount',
    description:
      'You are eligible for this discount if an insured driver on the policy, other than the primary named insured or spouse, is under the age of 23, a full-time student, and in good academic standing (e.g., 3.0 GPA/B average or better). Verification may be required.',
  },
  goodStudent25: {
    title: 'Good Student Discount',
    description:
      'You are eligible for this discount if an insured driver on the policy, other than the primary named insured or spouse, is under the age of 25, a full-time student, and in good academic standing (e.g., 3.0 GPA/B average or better). Verification may be required.',
  },
  homeowner: {
    title: 'Homeowner Discount',
    description:
      "You are eligible for this discount if you or your spouse's primary residence is a house, townhome, or condominium owned by you or your resident spouse.",
  },
  matureDriver50: {
    title: 'Mature Driver Discount',
    description: `You are eligible for this discount if you are 50 or older, have completed a course approved by the CA DMV during the preceding three years and have had not chargeable at-fault accident or traffic violations in the past three years. Verification may be required.`,
  },
  matureDriver55: {
    title: 'Mature Driver Discount',
    description: `A driver is eligible for this discount if they are 55 or older and have completed an approved motor vehicle accident prevention course.`,
  },
  matureDriver55ApprovedCourse: {
    title: 'Mature Driver Discount',
    description: `A driver is eligible for this discount if they are 55 or older and have completed an approved motor vehicle accident prevention course. The discount is not applicable if the course was required because of a moving traffic offense. If applied, the discount will be valid for three years after successful completion of a course. Verification may be required.`,
  },
  matureDriver55ApprovedCourseFL: {
    title: 'Mature Driver Discount',
    description:
      'A driver is eligible for this discount if they are 55 or older and have completed an approved motor vehicle accident prevention course by the Department of Highway Safety and Motor Vehicles. The discount is not applicable if the course was required because of a driving offense or traffic violation but if applied, will be valid for a three-year period. Verification may be required.',
  },
  matureDriver60: {
    title: 'Mature Driver Discount',
    description: `A driver is eligible for this discount if they are 60 or older and have completed an approved motor vehicle accident prevention course.`,
  },
  mixedPolicyRating: {
    title: 'Mixed Policy Rating Discount',
    description:
      'You are eligible for this discount if there are one or more Good Drivers(s) and one or more Non-Good Driver(s) list on the policy.',
  },
  multiCar: {
    title: 'Multi-Car Discount',
    description:
      'You are eligible for this discount if there is more than one (1) vehicle insured for liability coverage on the policy.',
  },
  multiCarCA: {
    title: 'Multi-Car Discount',
    description:
      'You are eligible for this discount if there is more than one (1) vehicle insured on the policy.',
  },
  multiPolicy: {
    title: 'Multi-Policy Discount',
    description:
      'You are eligible for this discount if you or your spouse has a second Toggle policy (renters, condo, townhome, homeowner).',
  },
  passiveRestraint: {
    title: 'Passive Restraint',
    description: `Your vehicle is eligible for this discount if it has a factory-installed air bag or other passive restraint system which meets Federal Safety Standards. "Passive Restraint" means any front seat protection system which requires no action from the people in the vehicle.`,
  },
  teenDriver: {
    title: 'Teen Driver Discount',
    description:
      'A driver is eligible for this discount if they are under the age of 19, single, a child of the primary named insured, and their previous policy had continuous coverage for twelve months prior to Toggle.',
  },
  threeYearSafeDriving: {
    title: 'Three Year Safe Driving Discount',
    description:
      'You are eligible for this discount if none of the insured drivers on the policy have had any accidents or traffic violations within the past 3 years.',
  },
  tnDirectDiscount: {
    title: 'Direct Discount',
    description:
      'You are eligible for this discount if you purchased your Toggle policy directly on our website (not through an affinity partner).',
  },
  safeDriving: {
    title: 'Safe Driving Discount',
    description:
      'You are eligible for this discount if all drivers on the policy have clean driving records.',
  },
  superiorDriver: {
    title: 'Superior Driver Discount',
    description:
      'You are eligible for this discount if you have been continuously licensed for the most recent four year period; have incurred no minor traffic convictions in the past three years; have incurred no major violations in the past ten years; and have not incurred a principally at-fault accident in the past four year period.',
  },
} as const;

type TGetAutoDiscounts = {
  discounts?: TDiscount[];
  discountsConfig: TConfig['discountsConfig'];
};

const getAutoDiscounts = ({
  discounts = [],
  discountsConfig,
}: TGetAutoDiscounts) => {
  const { partnerDiscounts = [], removedDiscounts = [] } =
    discountsConfig || {};

  return [...partnerDiscounts, ...discounts].filter(
    ({ title }) => !removedDiscounts?.includes(title)
  );
};

export default getAutoDiscounts;
